export default function MD01({ module }) {
    const item = module.items[0] || {};

    return (
        <div className="w-full p-4">
            <div className="max-w-2xl mx-auto my-8 p-4 bg-white rounded-lg shadow-lg">

                {/* Titre */}
                <h2 className="text-3xl font-bold mb-4">
                    {item.title || ""}
                </h2>

                {/* Conteneur vidéo responsive */}
                <div className="relative w-full" >
                    <iframe className="rounded-lg" width="100%" height="400px" src={item.link || ""} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen> </iframe>
                </div>

            </div>
        </div>
    );
}
